import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { AddOutcomeModalPage } from './add-outcome-modal.page';

const routes: Routes = [
  {
    path: '',
    component: AddOutcomeModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [AddOutcomeModalPage]
})
export class AddOutcomeModalModule { }
